import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  Text,
} from '@shared/ui';

export function SheetShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.sheet.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.sheet.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline">{t('uiLibrary.overlay.sheet.trigger')}</Button>
          </SheetTrigger>
          <SheetContent side="right" closeLabel={t('common.close')}>
            <SheetHeader>
              <SheetTitle>{t('uiLibrary.overlay.sheet.panelTitle')}</SheetTitle>
              <SheetDescription>{t('uiLibrary.overlay.sheet.panelDescription')}</SheetDescription>
            </SheetHeader>
            <div className="mt-4 space-y-2">
              <Text size="sm" color="muted">
                {t('uiLibrary.overlay.sheet.panelBody')}
              </Text>
            </div>
          </SheetContent>
        </Sheet>
      </CardContent>
    </Card>
  );
}
